import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { nullSafePath } from '../../shared/helpers/null-safe-path';
import {
  IterativeApplicationModel,
  IterativeApplicationPartApplicationElement
} from '../job-service/service-models/IterativeApplicationModel';

@Component({
  selector: 'app-iterative-application-landing',
  templateUrl: './iterative-application-landing.component.html',
  styleUrls: ['./iterative-application-landing.component.scss']
})
export class IterativeApplicationLandingComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  private identifier: string;
  private subBrandIdentifier: string;
  model: IterativeApplicationModel;
  jobId: number;
  applicantId: string;

  constructor(private route: ActivatedRoute,
    private router: Router) { }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription.add(
      this.route.data.subscribe(
        componentData => {
          const iterativeApplicationPart = componentData.iterativeApplicationPart;

          this.subscription.add(this.route.data
            .subscribe((data: { model: IterativeApplicationModel }) => {
              this.model = data.model;
              if (data.model.completeApplicationPartRequestId) {
                sessionStorage.setItem('completeApplicationPartRequestId', data.model.completeApplicationPartRequestId.toString());
              }

              this.subscription.add(this.route.params.subscribe((params: Params) => {
                this.identifier = params['identifier'];
                this.subBrandIdentifier = params['subBrandIdentifier'];
                this.applicantId = params['applicantId'];
                this.jobId = params['jobId'];

                const partSortOrder = iterativeApplicationPart;

                localStorage.setItem('applicationId', this.model.applicationId.toString());
                localStorage.setItem(params['jobId'], this.model.jobTitle);

                this.navigateToStartOfIterativeApplicationPart(partSortOrder);
              }));
            }));
        })
    );
  }

  navigateToStartOfIterativeApplicationPart(partOrder: number) {
    if (this.model === undefined || this.model.iterativeApplicationParts === undefined) {
      return;
    }

    const iterativeApplicationPart = _.find(this.model.iterativeApplicationParts, p => p.sortOrder === partOrder);

    if (iterativeApplicationPart.elements === undefined) {
      return;
    }

    const sortedElements = _.sortBy(iterativeApplicationPart.elements, e => e.sortOrder);
    
    this.handleRouting(sortedElements[0]);
  }

  private handleRouting(element: IterativeApplicationPartApplicationElement) {
    if (element === undefined) {
      return;
    }

    const basePath = nullSafePath(this.identifier, this.subBrandIdentifier, 'jobs', this.jobId, 'apply', this.applicantId);

    if (element.type === 'Custom' || element.type === 'AutoScore') {
      this.router.navigate([...basePath, 'survey', element.id]);
    } else if (element.type === 'EducationHistory') {
      this.router.navigate([...basePath, 'education-history']);
    } else if (element.type === 'EmploymentHistory') {
      this.router.navigate([...basePath, 'employment-history']);
    } else if (element.type === 'References') {
      this.router.navigate([...basePath, 'references']);
    } else if (element.type === 'EeoForm' || element.type === 'OfccpForm') {
      this.router.navigate([...basePath, 'voluntary-identification']);
    } else if (element.type === 'Certification') {
      this.router.navigate([...basePath, 'review-and-submit']);
    }
  }

}
